import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";

import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";

import { environment } from "./../../../environments/environment";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { AppConfig } from "./../../../app/app.config";
import { UserService } from "./../../_services/user.service";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";

@Component({
  selector: "app-addPatToDocList",
  templateUrl: "./addPatToDocList.component.html",
  styleUrls: ["./addPatToDocList.component.scss"],
})
export class AddPatientToPhysicianListComponent implements OnInit {
  loggedInUserId: string;
  patientId: string;
  showLoader = false;
  resultJsonObj: any = {};
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  supportMail = ConstantHelper.SUPPORT_EMAIL;
  message = Message;
  isDisabled: boolean = false;
  patientName: string;
  mobile: any;

  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sweetAlertHelper: SweetAlertHelper,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private userService: UserService
  ) {
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.patientId =
    this.activatedRoute.snapshot.paramMap.get("patientId");
  }

  async ngOnInit() {
    this.fetchStatus();
    this.findUserDetails(this.patientId);
  }

  async fetchStatus() {
    const finalData = {
      patientId: this.patientId,
      physicianId: this.loggedInUserId,
    };
    this.showLoader = true;
    try {
      this.http
      .post(
        this.appConfig.getLambdaUrl06() + ApiHelper.checkStatus,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          if (res == 0) {
            this.isDisabled = true; 
          } else {
            this.isDisabled = false;
          }
          this.showLoader = false;
        },
      )
    } catch (err) {
      console.error("Error fetching status:", err);
      return false;

    }
  }
  
  findUserDetails(demographicUserId) {
    const finalData = {
      id: demographicUserId,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.name_findUserDetailsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.patientName = this.userService.getUS_FromatName(
            apiResponse.commandResult.data.userInfo.FullName
          );
          this.mobile = apiResponse.commandResult.data.userInfo.Mobile;
          this.showLoader = false;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

// async addPatientToPhysician() {
//     this.showLoader = true; // Start loader
  
//     // Prepare data for both API calls
//     const finalData = {
//       company_slug: ConstantHelper.COMPANY_SLUG,
//       loggedInUserId: this.loggedInUserId,
//       patientId: this.patientId,
//       status: 'A'
//     };
//     const emailData = {
//       loggedInUserId: this.loggedInUserId,
//       patientId: this.patientId
//     }
//     const smsData = {
//       physicianId: this.loggedInUserId,
//       mobileNumber: ""
//     }
//   console.log(finalData,">email",emailData)
//     try {
//       // Call first API: Add patient to physician list
//       await this.http
//         .post(
//           this.appConfig.getLambdaUrl06() + ApiHelper.addRemovepatientFromDoctorList,
//           finalData,
//           this.httpOptions
//         )
//         .toPromise();
//       this.http
//         .post(
//           this.appConfig.getLambdaUrl06() + ApiHelper.emailForAddingDoctorToPatientList,
//           emailData,
//           this.httpOptions
//         )
//         .subscribe(
//           (res: any) => {
//           //sent an sms 
//           try{
//             const smsResponse =  this.http
//               .post(
//                 this.appConfig.getLambdaUrl06() + ApiHelper.smsForAddDocToPatientList,
//                 smsData,
//                 this.httpOptions
//               )
//               .toPromise();

//               console.log("SMS",smsResponse)
//           }catch(res){
//             console.error("Error", res);
//           }
//           this.showLoader = false;
//           },
//         (err) => {
//             console.error("Error while sending email:", err);
//             this.showLoader = false;
//           }
//         );
  
//       // Show success alert
//       const alertStatus = await this.sweetAlertHelper.alertPopUp(
//         this.message.alertMessages.demographicsComp.addPatient
//       );
  
//       if (alertStatus) {
//         this.isDisabled = true;
//       }
//     } catch (error) {
//       console.error("Error while adding patient:", error);
//       this.showLoader = false;
//     }
//   }

async addPatientToPhysician() {
  this.showLoader = true; // Start loader

  // Prepare data for both API calls
  const finalData = {
    company_slug: ConstantHelper.COMPANY_SLUG,
    loggedInUserId: this.loggedInUserId,
    patientId: this.patientId,
    status: 'A'
  };
  const emailData = {
    loggedInUserId: this.loggedInUserId,
    patientId: this.patientId
  };
  const smsData = {
    physicianId: this.loggedInUserId,
    mobileNumber: this.mobile
  };

 
  try {
    // Call first API: Add patient to physician list
    await this.http
      .post(
        this.appConfig.getLambdaUrl06() + ApiHelper.addRemovepatientFromDoctorList,
        finalData,
        this.httpOptions
      )
      .toPromise();

    // Call second API: Send email after adding doctor to patient list
    this.http
      .post(
        this.appConfig.getLambdaUrl06() + ApiHelper.emailForAddingDoctorToPatientList,
        emailData,
        this.httpOptions
      )
      .subscribe(
        async (emailRes: any) => {
          console.log("Email API Response:", emailRes);

          try {
            // Send SMS only after email API succeeds
            const smsResponse = await this.http
              .post(
                this.appConfig.getLambdaUrl06() + ApiHelper.smsForAddDocToPatientList,
                smsData,
                this.httpOptions
              )
              .toPromise();

            console.log("SMS API Response:", smsResponse);
          } catch (smsError) {
            console.error("Error while sending SMS:", smsError);
          }

          this.showLoader = false; // Hide loader after SMS API call
        },
        (emailErr) => {
          console.error("Error while sending email:", emailErr);
          this.showLoader = false;
        }
      );

    // Show success alert
    const alertStatus = await this.sweetAlertHelper.alertPopUp(
      this.message.alertMessages.demographicsComp.addPatient
    );

    if (alertStatus) {
      this.isDisabled = true;
    }
  } catch (error) {
    console.error("Error while adding patient:", error);
    this.showLoader = false;
  }
}

  

  async goToMainSite() {
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminChangePassComp.onReset
    );
    if (alertStatus) {
      // if (confirm("PLEASE CONFIRM: Are you certain you want to return to your Home Page?"))

      window.open(
        this.userService.parentSiteUrl() + "/dashboard/" + this.loggedInUserId,
        "_self"
      );
    }
  }
}
